<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item['cobitkat']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item['bezeichnung']}}</span>
  </div>
</div>
